import { Link } from 'react-router-dom';

const offerings = [
  {
    icon: 'ri-shield-star-line',
    title: 'Elite Security',
    description: 'Our professional security team ensures a safe, controlled environment so you can enjoy your night worry-free. Strict door policy, CCTV surveillance, and trained personnel on-site at all times.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'VIP Tables & Bottle Service',
    description: 'Reserve your exclusive VIP table and enjoy premium bottle service with dedicated hosts. Elevate your night with the finest spirits and personalized attention.',
  },
  {
    icon: 'ri-music-2-line',
    title: 'World-Class DJs',
    description: 'Experience electrifying sets from top-tier DJs every weekend. From Afrobeats to Amapiano and international hits — the dance floor never stops.',
  },
  {
    icon: 'ri-camera-line',
    title: 'Live Performances',
    description: 'Enjoy surprise celebrity appearances, live acts, and themed performances that make every night at King Square Club a one-of-a-kind experience.',
  },
  {
    icon: 'ri-sparkling-line',
    title: 'Luxury Ambiance',
    description: 'Immerse yourself in a stunning venue designed with opulence in mind — dramatic lighting, premium interiors, and an atmosphere that screams exclusivity.',
  },
];

export default function WhatWeOffer() {
  return (
    <section className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-amber-500 text-sm font-semibold tracking-widest uppercase mb-3">The Experience</p>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">What We Offer</h2>
          <div className="w-20 h-1 bg-amber-500 mx-auto mb-6"></div>
          <p className="text-white/60 text-base max-w-xl mx-auto">
            King Square Club delivers an unmatched luxury nightlife experience in Benin City — every detail crafted for the elite.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {offerings.map((item, index) => (
            <div
              key={index}
              className="group bg-zinc-900 hover:bg-zinc-800 border border-zinc-800 hover:border-amber-500/40 rounded-xl p-8 transition-all duration-400 cursor-default"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-amber-500/10 rounded-xl mb-5 group-hover:bg-amber-500/20 transition-colors duration-300">
                <i className={`${item.icon} text-amber-500 text-3xl`}></i>
              </div>
              <h3 className="text-white text-lg font-bold mb-3">{item.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        {/* Reservation CTA */}
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/36fa5f7443a7b055b7f1d9f1fe330f68.jpg"
            alt="King Square Club Interior"
            className="w-full h-72 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/40"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <p className="text-amber-400 text-sm font-semibold tracking-widest uppercase mb-3">Reserve Your Spot</p>
            <h3 className="text-white text-3xl md:text-4xl font-bold mb-4">
              Ready for an Unforgettable Night?
            </h3>
            <p className="text-white/70 text-base mb-8 max-w-lg">
              Secure your VIP table at Benin City's most exclusive club. Limited spots available every weekend.
            </p>
            <Link
              to="/contact"
              className="bg-amber-500 hover:bg-amber-600 text-black px-10 py-4 rounded-full text-base font-bold transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer inline-block"
            >
              Book Your Reservation
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
